/* eslint no-param-reassign: "error" */

export default {
  SET_IS_SHOW_FIRST_ELEMENT(state, data) {
    state.isShowFirstElement = data.isShowFirstElement;
    state.selectRef = data.ref;
  },
};
